export const DOCTOR_PREFERENCE_FIELD_NAMES: Readonly<string[]> = [
    'Occlusal Contact Tightness',
    'Proximal Contact Tightness',
    'No Occlusal Clearance',
    'Anatomical Design Preference',
];
